import { ApiErrorDTO } from "@bvhi/backend-api/apis/model/apiErrorDTO";
import { Alert } from "@bvhi/ui-base";
import { ErrorIcon } from "@bvhi/ui-icons";
import { useMemo } from "react";
import { useErrorObjectMapper } from "../hooks/use-error-object-mapper";

interface Props {
  error: ApiErrorDTO | null;
}

export const BVHIErrorsAlerts = ({ error }: Props) => {
  const { getErrorMessagesFromErrorObject } = useErrorObjectMapper();

  const errorMessages = useMemo(() => {
    if (!error?.errors) return [];
    return getErrorMessagesFromErrorObject(error);
  }, [error, getErrorMessagesFromErrorObject]);

  if (!(errorMessages.length > 0)) return false;

  return errorMessages.map((errItem) => (
    <Alert key={errItem} icon={<ErrorIcon />} severity="error">
      {errItem}
    </Alert>
  ));
};
